import { FeaturesList } from "types/Features";
import { ENV } from "types/envs";
import { getEnvFromHost } from "utils/getEnvFromHost";
import getOpco from "utils/getOpco";

import dit3Features from "assets/features/dit3.json";
import preFeatures from "assets/features/pre.json";
import prodFeatures from "assets/features/prod.json";

const getFeatures = () => {
  const {
    location: { host },
  } = window;

  const env: ENV = getEnvFromHost(host);

  const features: FeaturesList = env === "DIT" ? dit3Features : env === "PRE" ? preFeatures : prodFeatures;

  return features[getOpco()];
};

export default getFeatures;
